export const normalizeOrderItem = (item) => {
    if (!item) return null;
    return {
        product_id: item.product_id,
        name: item.name,
        image: item.image || "",
        product_type: item.product_type || "book",
        price: Number(item.price || 0),
        credits: Number(item.credits || item.price || 0),
        issue_or_return: item.issue_or_return || "issue",
        quantity: Number(item.quantity || 1),
        line_subtotal: Number(item.line_subtotal || 0),
        stock_status: item.stock_status || "instock",
        copy_post_id: item.copy_post_id || 0
    };
};

export const normalizeOrderFromList = (order) => {
    if (!order) return null;
    const rawItems = order.items || order.line_items || [];
    return {
        order_id: order.order_id,
        status: order.status,
        date_created: order.date_created || "",
        item_count: Number(order.item_count || 0),
        total: Number(order.total || 0),
        user_id: order.user_id,
        items: Array.isArray(rawItems) ? rawItems.map(normalizeOrderItem) : []
    };
};

export const normalizeOrderDetails = (orderData) => {
    if (!orderData) return null;
    const rawItems = orderData.items || orderData.line_items || [];
    return {
        order_id: orderData.order_id,
        order_number: orderData.order_number,
        order_status: orderData.order_status,
        order_date: orderData.order_date || "",
        payment: {
            payment_status: orderData.payment?.payment_status || "",
            paid_at: orderData.payment?.paid_at || "",
            paid_on: orderData.payment?.paid_on || "",
            ip_address: orderData.payment?.ip_address || "",
            transaction_id: orderData.payment?.transaction_id || ""
        },
        shipping_details: {
            shipment_status: orderData.shipping_details?.shipment_status || "",
            shipment_provider: orderData.shipping_details?.shipment_provider || "",
            etd: orderData.shipping_details?.etd || "",
            courier: orderData.shipping_details?.courier || "",
            awb: orderData.shipping_details?.awb || "",
            tracking_url: orderData.shipping_details?.tracking_url || "",
            shipping_address: orderData.shipping_details?.shipping_address || "",
            delivery_option: orderData.shipping_details?.delivery_option || ""
        },
        slot_details: orderData.slot_details || null,
        order_details: {
            order_status: orderData.order_details?.order_status || "",
            issue_credits: Number(orderData.order_details?.issue_credits || 0),
            return_credits: Number(orderData.order_details?.return_credits || 0),
            available_credits: Number(orderData.order_details?.available_credits || 0),
            total_amount: Number(orderData.order_details?.total_amount || 0)
        },
        items: Array.isArray(rawItems) ? rawItems.map(normalizeOrderItem) : []
    };
};

export const normalizeMember = (rawMember, liveCredits) => {
    if (!rawMember) return null;
    return {
        id: rawMember.id,
        name: rawMember.member_name,
        phone: rawMember.phone_number,
        email: rawMember.email,
        dob: rawMember.date_of_birth,
        subscription: rawMember.subscription_plan,
        deposit: rawMember.deposit,
        damageCharges: rawMember.damage_charges,
        credits: liveCredits,
        billing_address: rawMember.billing_address,
        overdue_charges: rawMember.overdue_charges || 0,
        overdue_charges_details: rawMember.overdue_charges_details || []
    };
};

export const normalizeCart = (cartData, subtotal, total, itemCount) => {
    const rawCart = cartData || [];
    const items = Array.isArray(rawCart) ? rawCart.map(normalizeOrderItem) : [];
    return {
        items,
        cart_item_count: itemCount !== undefined ? itemCount : items.length,
        cart_subtotal: subtotal !== undefined ? subtotal : 0,
        cart_total: total !== undefined ? total : 0
    };
};
